/* @ngInject */

export default () => {
  function compile(el) {
    el.find('.md-datepicker-button').remove();

    el.find('input').attr('ng-click', 'ctrl.onClick($event)').next().remove();

    return function (scope, element, attrs, datePicker) {
      datePicker.onClick = function (event) {
        datePicker.ngInputElement.blur();
        datePicker.openCalendarPane(event);
      };
      datePicker.ngInputElement.on('keydown', function (event) {
        return false;
      });
      datePicker.ngInputElement.on('focus', function (event) {
        datePicker.ngInputElement.blur();
      });
    };
  }

  return {
    compile: compile,
    priority: -1,
    require: 'mdDatepicker',
    restrict: 'A'
  };
};
